var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonicIosMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.293,
    height: 22.289,
    viewBox: "0 0 22.293 22.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#818ca4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.313,12.9,20.366,8.949a.69.69,0,0,0-.974,0l-.01.01a.69.69,0,0,0,0,.974l2.73,2.73-8.045.025.025-8.045,2.73,2.73a.69.69,0,0,0,.974,0l.01-.01a.69.69,0,0,0,0-.974L13.857,2.441a.69.69,0,0,0-.974,0L8.935,6.389a.69.69,0,0,0,0,.974l.01.01a.69.69,0,0,0,.974,0l2.73-2.73.025,8.045-8.045-.025,2.73-2.73a.69.69,0,0,0,0-.974l-.01-.01a.69.69,0,0,0-.974,0L2.427,12.9a.69.69,0,0,0,0,.974l3.948,3.948a.69.69,0,0,0,.974,0l.01-.01a.69.69,0,0,0,0-.974L4.629,14.1l8.045-.025-.025,8.045L9.919,19.4a.69.69,0,0,0-.974,0l-.01.01a.69.69,0,0,0,0,.974l3.948,3.948a.69.69,0,0,0,.974,0L17.8,20.38a.69.69,0,0,0,0-.974l-.01-.01a.69.69,0,0,0-.975,0l-2.73,2.73-.025-8.045,8.045.025-2.73,2.73a.69.69,0,0,0,0,.974l.01.01a.69.69,0,0,0,.974,0l3.948-3.948A.681.681,0,0,0,24.313,12.9Z",
    transform: "translate(-2.225 -2.239)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicIosMove);
export default __webpack_public_path__ + "static/media/ionic-ios-move.021b2bdb335c8a782c8b944f54255e4a.svg";
export { ForwardRef as ReactComponent };